import { IAbcComponent, StylingMode } from '../abcComponent.model';

export interface IInput extends IAbcComponent {
  placeholder?: string;
  type?: InputType;
  value?: any;
  decimalDigits?: Number;
  symbol?: string;
  editMask?: string;
  label?: string;
  visible?: boolean;
  focusStateEnabled?: boolean;
  isValid?: boolean;
  mode?: InputMode;
  step?: number;
  name?: string;
  readOnly?: boolean;
  disabled?: boolean;
  showClearButton?: boolean;
  showMaskMode?: ShowMaskMode;
  stylingMode?: StylingMode;
  validationStatus?: InputValidationStatus;
  rtlEnabled?: boolean;
  inputButton?: boolean;
  matRequired?: boolean;
  showSpinButtons?: boolean;
  inputAttr?: any;
  min?: number;
  max?: number;
  valueChangeEvent?: ValueChangeEvent;
  setInputStyle(style?: InputStyle);
  setCustomDataAttributes(data?: Object);
}

export class InputStyle {
  height?: string | number;
  width?: number | string = '100%';
  maxLength?: number;
  popupZIndex?: number;
}

export enum InputType {
  color = 'color',
  date = 'date',
  datetimeLocal = 'datetime-local',
  email = 'email',
  month = 'month',
  number = 'number',
  password = 'password',
  search = 'search',
  tel = 'tel',
  text = 'text',
  time = 'time',
  url = 'url',
  week = 'week',
}
export enum InputMode {
  Email = 'email',
  Password = 'password',
  Search = 'search',
  Tel = 'tel',
  Text = 'text',
  Url = 'url',
  Number = 'number',
}

export enum ShowMaskMode {
  Always = 'always',
  OnFocus = 'onFocus',
}
export enum InputStylingMode {
  Outlined = 'outlined',
  Underlined = 'underlined',
  Filled = 'filled',
}

export enum InputValidationStatus {
  Valid = 'valid',
  Invalid = 'invalid',
  Pending = 'pending',
}

export enum ValueChangeEvent {
  Keyup = 'keyup',
  Blur = 'blur',
  Change = 'change',
  Input = 'input',
  Focusout = 'focusout',
}
